module.exports = __webpack_public_path__ + "js/0.13bdeb81.worker.js"